// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// Environment
import { environment } from 'environments/environment';
import { IntakeService } from 'app/intake/intake-services/intake.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})

export class CommonService {
    SERVER_URL: string = environment.apiProtocol + environment.Services.AlphaURL;
    AlphaSolt2: string = environment.apiProtocol + environment.Services.AlphaURLSlot2;
    //SERVER_URL: string = "https://localhost:44348";

    constructor(private httpClient: HttpClient,
        private intakeService : IntakeService) { }

    private createCompleteRoute(route: string, envAddress: string) {
        return `${envAddress}/${route}`;
    }

    private createCompleteRouteWithProtocol(Protocol: string, route: string, envAddress: string) {
        return `${Protocol}/${envAddress}/${route}`;
    }


    public getData(route: string, serverUrl: string, includeCache:boolean=false) {
        return this.httpClient.get(
            this.createCompleteRouteWithProtocol(environment.apiProtocol, route, serverUrl), this.generateHeaders(includeCache)
        );
    }

    public create(route: string, body) {
        return this.httpClient.post(
            this.createCompleteRoute(route, this.AlphaSolt2),
            body,
            this.generateHeaders()
        );
    }

    public update(route: string, body) {
        return this.httpClient.put(
            this.createCompleteRoute(route, this.AlphaSolt2),
            body,
            this.generateHeaders()
        );
    }

    public updateDossierStatus(route: string, body) {
        return this.httpClient.put(
            this.createCompleteRoute(route, this.AlphaSolt2),
            body,
            this.generateHeaders()
        );
    }

    public updateDossierIsUrgent(route: string, body) {
        return this.httpClient.put(
            this.createCompleteRoute(route, this.SERVER_URL),
            body,
            this.generateHeaders()
        );
    }
    public delete(route: string) {
        return this.httpClient.delete(
            this.createCompleteRoute(route, this.SERVER_URL)
        );
    }

    public getVecozosearchResult(route: string, body) {
        body.Birthdate = this.intakeService.getLocalDate(body.Birthdate);
        body.InsuranceReferenceDate = this.intakeService.getLocalDate(body.InsuranceReferenceDate);
        return this.httpClient.post(
            this.createCompleteRoute(route, environment.apiProtocol + environment.Services.CommonBaseURL),
            body,
            this.generateHeaders()
        );
    }

    public getNumberOpenDossierByClient (route: string) : Observable<any>{
        return this.httpClient.get(
            this.createCompleteRoute(route, this.SERVER_URL), this.generateHeaders()
        );
    }
    private generateHeaders(includeCache: boolean = false) {
        let headersConfig = {
            'Content-Type': 'application/json'
        };
        if (!includeCache) {
            headersConfig['Cache-Control'] = 'no-cache';

        }
        return {
            headers: new HttpHeaders(headersConfig),
        };
    }
}